import { Button } from "reactstrap";
import { useEffect } from "react";
import { useState } from "react";
import StandardSlider from "./StandardSlider";
import { RxCross2 } from "react-icons/rx";

const FullScreenView = () => {
  const [isShown, setisShown] = useState(false);
  const [currentShownImages, setCurrentShownImages] = useState([]);
  const [originStyle, setOriginStyle] = useState(``);
  const [viewType, setViewType] = useState("image");
  const [videoSrc, setVideoSrc] = useState("");
  console.log(currentShownImages, "origin", originStyle);

  useEffect(() => {
    const listener = (e) => {
      let { images, video } = e?.detail;

      if (video) {
        setCurrentShownImages([]);
        setViewType("video");
        setVideoSrc(video);
        setisShown(true);
        return;
      }
      setViewType("image");
      setCurrentShownImages(
        JSON.parse(images)?.map((imgsrc) => (
          <img
            src={imgsrc}
            style={{
              height: "100dvh",
              width: "100dvw",
            }}
            className="full-width object-fit-cover "
            alt="place-img"
          />
        ))
      );
      const boundingBox = e?.detail?.element?.getBoundingClientRect();
      setOriginStyle(`${boundingBox?.top}px ${boundingBox?.left}px`);

      setisShown(true);
    };
    window?.addEventListener("ce-carousel-full-view", listener);
    return () => window?.removeEventListener("ce-carousel-full-view", listener);
  }, []);

  if (isShown)
    return (
      <div className="full-screen-carousel">
        <Button
          onClick={() => setisShown(false)}
          className="bg-white d-flex align-items-center border-none position-absolute justify-content-center text-black"
          style={{
            height: 50,
            width: 50,
            borderRadius: "50%",
            top: "10px",
            right: "15px",
            zIndex: 5,
          }}
        >
          <RxCross2 size={40} />
        </Button>
        <div className="content">
          {viewType === "image" ? (
            <StandardSlider items={currentShownImages} />
          ) : (
            <video
              src={videoSrc}
              className="full-width object-fit-cover"
              controls
              style={{ height: "100vh" }}
            />
          )}
        </div>
      </div>
    );
};

/**fires a full screen event  */
const showInFullScreen = (element, images, video) => {
  let event = new CustomEvent("ce-carousel-full-view", {
    detail: { images: JSON.stringify(images), element: element, video: video },
  });
  console.log("firing event", event);
  window?.dispatchEvent(event);
};

export { FullScreenView, showInFullScreen };
